"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseTransform =
/** @class */
function () {
  function BaseTransform(options, translationHelper, callStackLevel) {
    this.options = options;
    this.translationHelper = translationHelper;
    this.callStackLevel = callStackLevel;
  }

  return BaseTransform;
}();

exports.BaseTransform = BaseTransform;